
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"7","y":"2.4","width":"2","height":"2.4","rx":"1","stroke":"#112A46"}}),_c('rect',{attrs:{"x":"7","y":"8.4","width":"2","height":"2.4","rx":"1","stroke":"#112A46"}}),_c('rect',{attrs:{"x":"7","y":"14.4","width":"2","height":"2.4","rx":"1","stroke":"#112A46"}})])
          )
        }
      }
    